import Plugin from '@antv/g6-plugin';
export default Plugin;
// export default {};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/g6-pc/es/plugin/index.js
// module id = null
// module chunks = 